import React from "react";
import about from "../../../assets/img/projects/People/People-about.png";
import { useScrollAnim } from "../../hook/useScrollAnim";
import { useTranslation } from "react-i18next";

function AboutUs() {
  const { t } = useTranslation();
  const containerRef = useScrollAnim({
    selector: "img, article",
    threshold: 0.3,
    once: true,
  });

  const paragraphs = t("people.about.text").split("\n\n"); // nouveaux <p>

  return (
    <div className="people-about" ref={containerRef}>
      <img className="about_img" src={about} alt="About People Restaurant" />
      <article className="about_text">
        <h1>{t("people.about.title")}</h1>

        {paragraphs.map((para, i) => (
          <p
            key={i}
            // rend <u>…</u> et convertit \n => <br />
            dangerouslySetInnerHTML={{
              __html: para.replace(/\n/g, "<br />"),
            }}
          />
        ))}
      </article>
    </div>
  );
}

export default AboutUs;
